// extracted by mini-css-extract-plugin
export default {"homeHeader":"Header_homeHeader__Otu1D","title":"Header_title__l+wMf","imageDesign":"Header_imageDesign__CGoAL","nameUser":"Header_nameUser__wCFSn"};